import { FilterTypes } from '@/component/FilterCommon/Filter';
import React from 'react';

import { DhbNavBar } from '@/component/PageComponentMobile/head';
import { DhbFilterMobile } from '@/component/FilterMobile/FilterMobile';
import { styled } from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import { useLocation, useSearchParams,useNavigationType, useNavigate} from 'react-router-dom'
import { requestLoading } from '@/hooks/hooksPc/useRequestLoadingPc';
import { serviceQuickBiReportConfigMobile, serviceQuickBiReportDataMobile, serviceQuickBiReportTemplateMobile } from '@/component/ReportMobile/services/bi/bi';

import { useParams, Outlet, useOutlet } from 'react-router-dom'
import { requestLoadingMobile } from '@/hooks/hooksMobile/useRequestLoadingMobile';
import { ReportConfig,ReportParams,getDefaultParams,ServiceQuickBiReportDataParams, encryptReportFilterSelectParams, encryptReportRequestParams} from '@/component/common/report/report';
import { CustomCard } from '@/component/ReportMobile/CustomCard/CustomCard';
import { PageInfoBase, useGetData } from '@/component/PageComponent/hooks/requst';
import { TableList } from '@/component/ReportMobile/CustomTable/TableList';
import _ from 'lodash'
import { isErrorMobile } from '@/component/PageComponentMobile/error';
import { CountType, TableBaseParamsType, getSource, isValidTableBaseParams } from '@/component/ReportCommon/share/params';
import { FilterModule } from '@/component/common/report/reportConfigModel';
import { AlertMenu } from '@/component/Alert/AlertMenu/AlertMenu';
import { AlertMenuMobile } from './AlertMenuMobile';
import { goBackApp } from '@/utils/utils';
import { getTransmferFields } from '@/component/Report/CustomTable/utils/utilsTable';







const MobileReportView = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  .table-list{
    flex: 1;
    overflow-y: auto;
  }

`
const GlobalStyle = createGlobalStyle`
  *{
    box-sizing: border-box;
  }
  :root:root {
    --adm-color-primary: #FF7557;
  }
`;
interface ReportMobileProps {
  source:string,
  configData:ReportConfig
  goBack:()=>void
}
//http://wiki.dhb168.com/pages/viewpage.action?pageId=56298297  文档地址

const ReportMobile = (props:ReportMobileProps) => {
  let childOutLet = useOutlet()
  const [ searchParams ] = useSearchParams()
  let {reportName = ''} = useParams<{reportName:string}>()
  const [reportTableData,setReportTableData] = React.useState<Array<Record<string,string|number>>>([]);
  type PageParams = Omit<ServiceQuickBiReportDataParams,'source'>
  const defaultParamsRef = React.useRef<PageParams|undefined>()
  const tableBaseParamsRef = React.useRef<TableBaseParamsType>({})
  const [configData,setConfig] = React.useState<ReportConfig|undefined>()

  let nagative = useNavigate()
  const [hasMore,setHasMore] = React.useState(true)
  async function getBiReportList (params: PageParams){
    if(!isValidTableBaseParams(tableBaseParamsRef.current)){
      return
    }
    if(params.page === 1){
      setReportTableData([])
    }
    let transformer_fields = getTransmferFields(configData);
    let tableBaseParams = tableBaseParamsRef.current
    const { source_count,...rest } = tableBaseParams
    const requestParams = encryptReportRequestParams({
      configData: props.configData,
      requestParams: params,
    })
    let reportData =  await requestLoadingMobile(
      serviceQuickBiReportDataMobile({
        ...requestParams, ...rest,transformer_fields, count: CountType.isRequestTable,
      })
    )
    if (isErrorMobile(reportData)) {
      return
    }
    setReportTableData((pre)=>{
      let list = pre
      if(params.page === 1){
        list = []
      }
      let listData = reportData.data.data.listsData
      let hasMore = listData.length >= Number(params.pageSize)
      setHasMore(hasMore)
      return [...list,...reportData.data.data.listsData]
    })
  }

  const dataHandler = useGetData<ReportParams>({getData: getBiReportList, defaultPageInfo:{ page:1,pageSize:20 } })
  
  function getConfig(configData:ReportConfig){
    // let resConfigData = await requestLoadingMobile(serviceQuickBiReportConfigMobile({report: reportName}));
    // if(isErrorMobile(resConfigData)){
    //   return
    // }
    // let configData= resConfigData.data.data
    console.log("config",configData)
    let {defaultParams,report_config} = getDefaultParams(configData)
    if(report_config){
      configData.config.report_config = report_config
    }
    defaultParamsRef.current = _.cloneDeep(defaultParams)
    
    setConfig(configData)
    let report = configData?.config.slug
    let {source,template_code,menuItem,source_count} = getSource(configData?.config.report_config)
    /** 报表预警 */
    if(props.source){
      source = props.source
    }
    tableBaseParamsRef.current = {
      report,source,template_code,source_count
    }
    dataHandler.setParams({...defaultParamsRef.current,count: CountType.isRequestAll})
  }
  React.useEffect(()=>{
    getConfig(props.configData)
  },[])

  const renderFilter = ()=>{
    let filterModule = configData?.config.report_config.modules.find(item => {
      return item.type == 'filter'
    }) as FilterModule
    if (!filterModule) {
      return undefined
    }
    let filters = filterModule.list
    return <DhbFilterMobile
      defaultParams={defaultParamsRef.current}
      params={dataHandler.params}
      onSearch={(_params) => {
        dataHandler.setParams({..._params,sortParams: dataHandler.params.sortParams,count: CountType.isRequestAll})
      }}
      filterProps={{
        filters: filters
      }}
  />
  }

  const renderList = ()=>{
    return configData?.config.report_config.modules.map(moduleItem=>{
      if(moduleItem.type == 'card'){
        return <CustomCard  key={moduleItem.type}  reportConfig={configData} moduleItem={moduleItem}  dataHandler={dataHandler}   />
      }
      if(moduleItem.type == "table"){
        return <TableList 
          key={moduleItem.type} 
          source={ tableBaseParamsRef.current.source || ''} 
          hasMore={hasMore}
          reportConfig={configData} 
          reportTableData={reportTableData} 
          moduleItem={moduleItem} 
          dataHandler={dataHandler}
        />
      }
    })
  }

  // if(configData?.config.report_config.alertMenu?.show && alertMenuShow){
  //   return <AlertMenuMobile
  //     reportConfig={configData}
  //     onChangeAlertMenuItem={(menuItem)=>{
  //       setAlertMenuShow(false)
  //       tableBaseParamsRef.current.source = menuItem.key
  //       dataHandler.setParams({...dataHandler.params,count: CountType.isRequestAll})
  //     }}
  //   />
  // }

  return (
    <div>
      <MobileReportView style={{display:  childOutLet ? 'none' : 'flex'}} >
        {/* <GlobalStyle/> */}
        <DhbNavBar
          title={ configData?.config?.report_name }
          onBack={()=>{
            props.goBack()
          }}
          rightSlot={renderFilter()}
        ></DhbNavBar>
        <div className='table-list'>
          {renderList()}
        </div>
      </MobileReportView>
      <Outlet />
    </div>
  );
};

export default ()=>{
  const [configData,setConfig] = React.useState<ReportConfig|undefined>()
  let {reportName = ''} = useParams<{reportName:string}>()
  const [alertMenuShow,setAlertMenuShow] = React.useState(false)
  let [source,setSource] = React.useState('')
  const getConfig =  async ()=>{
    let resConfigData = await requestLoadingMobile(serviceQuickBiReportConfigMobile({report: reportName}));
    if(isErrorMobile(resConfigData)){
      return
    }
    const configData = resConfigData.data.data
    if(configData){
      encryptReportFilterSelectParams({ configData })
    }
    if(configData?.config?.report_config.alertMenu?.show){
      setAlertMenuShow(true)
    }
    setConfig(configData)
  }
  React.useEffect(()=>{
    getConfig()
  },[])
  const goBack = ()=>{
    if(configData?.config.report_config.alertMenu?.show && !alertMenuShow){
      setAlertMenuShow(true)
    }else{
      goBackApp()
      // nagative(-1)
    }
  }
  if(configData?.config.report_config.alertMenu?.show && alertMenuShow){
    return <AlertMenuMobile
      reportConfig={configData}
      onBack={goBack}
      onChangeAlertMenuItem={(menuItem)=>{
        setAlertMenuShow(false)
        setSource(menuItem.key)
        // tableBaseParamsRef.current.source = menuItem.key
        // dataHandler.setParams({...dataHandler.params,count: CountType.isRequestAll})
      }}
    />
  }
  if(!configData){
    return null
  }
  return <div>
    <ReportMobile  source={source} configData={configData} goBack={goBack} />
  </div>
}
